<mat-form-field appearance="standard" class="input-form">
  <mat-label class="label" translate>{{ label }}</mat-label>
  <input
    matInput
    class="input"
    [formControl]="control"
    placeholder="{{ placeholder }}"
    [attr.inputmode]="'numeric'"
    (blur)="handleInputBlur()"
    (focus)="handleInputFocus()"
    (keydown)="numberOnly($event)"
    disableRipple
  />
  <div matSuffix class="icon icon-{{ currencyIcon }}"></div>
  <mat-error *ngIf="error">
    {{ error }}
  </mat-error>
</mat-form-field>
